import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";

const feature_flags = createReducer([], (builder) => {
  builder.addCase(actionTypes.ANGULAR_INIT, (state, action) => {
    const { response = {} } = action;
    const { config_options = {} } = response;
    const { feature_flags = [] } = config_options;
    if (feature_flags.length > 0) {
      state = feature_flags;
    }
    return state;
  });
});

export default feature_flags;
